import axios from "~/plugins/axios";

export default {
  findById(policyViewGroupId, includes = []) {
    return axios.get(`/web_api/v1/policy_view_group/${policyViewGroupId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
};
